import { injectable } from '~/decorators/dependency-container'

@injectable()
export default class EventBuilderValidator {
  validate(value: any, label: string) {
    if (!value) {
      throw new TypeError(`${label} undefined`)
    }
  }
}
